import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Todos from './components/todos';
import Footer from './components/Footer';
import Header from './components/Header';
import About from './components/About';

function App() {
  const [todos, setTodos] = useState(() => {
    const storedTodos = localStorage.getItem("todos");
    return storedTodos
      ? JSON.parse(storedTodos)
      : [{ id: Date.now(), title: "leetcode", isComplete: true }];
  });

  useEffect(() => {
    localStorage.setItem("todos", JSON.stringify(todos));
  }, [todos]);

  const toggleCompleted = (id) => {
    const updatedTodos = todos.map(todo =>
      todo.id === id ? { ...todo, isComplete: !todo.isComplete } : todo
    );
    setTodos(updatedTodos);
  };

  const addTask = (newTask) => {
    if (newTask === "") {
      alert("Please enter a task");
    } else {
      const tsk = { id: Date.now(), title: newTask, isComplete: false };
      setTodos([...todos, tsk]);
    }
  };

  const onDelete = (task) => {
    let updatedTodos = todos.filter(todo => todo.id !== task.id);
    setTodos(updatedTodos);
  };

  return (
    <Router>
      <Header title="Todos" home="Home" />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <h1 className="text-center mt-2"><b>Todo List</b></h1>
              <div className="container p-2" style={{ minHeight: "70vh" }}>
                <Todos
                  todos={todos}
                  addTask={addTask}
                  onDelete={onDelete}
                  toggleCompleted={toggleCompleted}
                />
              </div>
            </>
          }
        />
        <Route path="/about" element={<About />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;